import { useCallback, useState } from 'react';

// Mirrors the reference toggleTheme(): flips data-theme on <html> between
// "light" and "dark"; the label reads ": Dark :" when a switch to dark is offered.
export const useTheme = () => {
  const [theme, setTheme] = useState(
    () => document.documentElement.getAttribute('data-theme') || 'light'
  );

  const toggleTheme = useCallback(() => {
    setTheme((current) => {
      const next = current === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', next);
      return next;
    });
  }, []);

  return { theme, toggleTheme };
};

export default useTheme;
